<template>
  <div>
    <el-form
      :model="addForm"
      label-width="120px"
      :rules="addFormRules"
      ref="addRuleForm"
      auto-complete="off"
      style="overflow-x: hidden; overflow-y: hidden; margin-right: 4%"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户" prop="OrgID">
            <el-select
              v-model="addForm.OrgID"
              placeholder="请选择客户"
              style="width: 100%"
              @change="onGetCachingBatchBox"
            >
              <el-option
                v-for="item in customerList"
                :label="item.customName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="仓库" prop="WarehouseId">
            <el-select
              v-model="addForm.WarehouseId"
              style="width: 100%"
              placeholder="请选择仓库"
              @change="getLogisticsChannels(), onGetCachingBatchBox(),getTransport()"
            >
              <el-option
                v-for="item in WareHouse"
                :label="item.warehouseName"
                :value="item.warehouseId"
                :key="item.warehouseId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="运输方式" prop="Transport">
            <el-select
              v-model="addForm.Transport"
              style="width: 100%"
              placeholder="运输方式"
              @change="getLogisticsChannels"
            >
              <el-option
                v-for="item in transportList"
                :label="item.transportTypeText"
                :value="item.transportTypeId"
                :key="item.transportTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="物流方式"
            prop="LogisticsChannelID"
            placeholder="运输方式"
          >
            <el-select v-model="addForm.LogisticsChannelID" style="width: 100%">
              <el-option
                v-for="item in channelList"
                :label="item.channelName"
                :value="item.logisticsChannelID"
                :key="item.logisticsChannelID"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户单号" prop="ContainerNo">
            <el-input
              v-model="addForm.ContainerNo"
              auto-complete="off"
              placeholder="请输入客户单号"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期望出货日期" prop="DeliveryDate">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="addForm.DeliveryDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="24">
          <el-form-item label="详细地址" prop="DesAddress">
            <el-input
              style="position: fixed; bottom: -9999px"
              type="text"
            ></el-input>

            <el-input
              v-model="addForm.DesAddress"
              placeholder="请输入详细地址"
              maxlength="200"
              type="text"
            ></el-input>

            <el-button @click="commonlyUsed" type="text" size="small"
              >选择常用地址</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="">
            <el-col style="float: left; width: 150px">
              <el-checkbox v-model="addForm.IsHandleThridBoxMark"
                >贴第三方箱唛</el-checkbox
              >
            </el-col>
            <el-col style="float: left; width: 200px">
              <el-checkbox v-model="addForm.IsHandleChannelBoxMark"
                >贴物流面单</el-checkbox
              >
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="">
          <el-button type="primary" plain @click="importExport"
            >导入箱明细</el-button
          >
          <el-button type="primary" plain @click="getBoxMarkDetailed"
            >选择箱明细</el-button
          >
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="">
          <div class="otherTable">
            <el-table-bar :fixed="true" :bottom="35">
              <el-table border :data="tableData" style="width: 100%">
                <el-table-column
                  prop="boxMark"
                  label="箱号"
                  sortable
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  label="FBA/海外仓箱号"
                  sortable
                  min-width="150"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.destinationBoxNo"
                      auto-complete="off"
                      placeholder="请输入FBA/海外仓箱号"
                      maxlength="50"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100">
                  <template slot-scope="scope">
                    <el-button
                      @click="delboxMark(scope.row.boxMark)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-table-bar>
            <div class="block">
              <el-pagination layout="total" :total="total" style="float: right">
              </el-pagination>
            </div>
          </div>
        </el-form-item>
      </el-row>
      <el-row type="flex" class="row-bg" justify="center">
        <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
          >提交</el-button
        >
      </el-row>
    </el-form>

    <!-- 导入箱明细 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="导入箱明细"
      width="50%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
              :auto-upload="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <el-button type="primary" @click="handleDownload()"
              >下载导入模板</el-button
            >
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="submitUpload"
              >导入箱明细</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <span style="color: red"> {{ Importtext }}</span>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 在库箱明细数据 -->
    <el-dialog
      :visible.sync="boxMarkVisible"
      v-model="boxMarkVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      :row-click="handleCellClick"
      title="在库存箱信息"
      width="80%"
      style="text-align: center"
      ref="multipleTable"
    >
      <div style="width: 100%; text-align: left; margin-bottom: 10px">
        <el-button type="primary" @click="onAddCachingBatchBox" style=""
          >选择</el-button
        >
      </div>
      <el-table
        :data="transferdata"
        highlight-current-row
        border
        style="width: 100%;heiht"
        @row-click="handleCellClick"
        @selection-change="selsChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="locationCode"
          label="仓位"
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="boxMark"
          label="箱号"
          sortable
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="batchCode"
          label="批次号"
          sortable
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="入库时间"
          sortable
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column label="箱规" align="center">
          <template slot-scope="scope">
            {{
              scope.row.boxLength +
              "*" +
              scope.row.boxWidth +
              "*" +
              scope.row.boxHeight
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="boxSingleCount"
          label="PCS数"
          sortable
          align="center"
        >
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagetotal"
          style="float: right"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 常用地址 -->
    <el-dialog
      :visible.sync="choiceVisible"
      v-model="choiceVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="常用地址"
      width="80%"
      style="text-align: center"
     
    >
      <el-table
        :data="choicedata"
        highlight-current-row
        border
        style="width: 100%;heiht"
      >
        <el-table-column
          prop="label"
          label="标签"
          sortable
          align="center"
          min-width="100"
        >
         </el-table-column>
   
        <el-table-column
          prop="address"
          label="详细地址"
          sortable
          align="center"
          min-width="400"
        >
        </el-table-column>
        <el-table-column label="操作" min-width="100"  align="center">
          <template slot-scope="scope">
            <el-button
              @click="choiceAddress(scope.row)"
              type="text"
              size="small"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerList } from "@/api/ProductSkuExcel.js";
import { getCountryList, getStateCityAreaTree } from "../../api/api";
import {
  getTransportType,
  getLogisticsChannelsByChannelName,
  downloadBatchBox,
  getBatchBoxDetail,
  getCachingBatchBox,
  addCachingBatchBox,
  importImportBatchBox,
  addReadyforTask,
  getStockingTaskById,
  getCommonAddressByOrgId,
} from "@/api/outbound/readyforTask.js";
import axios from "axios";
export default {
  data() {
    return {
      addForm: {
        StockingTaskID: 0,
        OrgID: "",
        WarehouseId: "",
        Transport: "",
        LogisticsChannelID: "",
        ContainerNo: "",
        DeliveryDate: "",
        DesAddress: "",    
        IsHandleThridBoxMark: false,
        IsHandleChannelBoxMark: false,
      },
      addFormRules: {
        OrgID: [{ required: true, message: "请选择客户", trigger: "change" }],
        WarehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        Transport: [
          { required: true, message: "请选择运输方式", trigger: "change" },
        ],
        LogisticsChannelID: [
          { required: true, message: "请选择物流方式", trigger: "change" },
        ],
        

        ContainerNo: [
          { required: true, message: "请输入客户单号", trigger: "blur" },
          {
            message: "输入数字、字母",
            trigger: "blur",
            pattern: /^[0-9a-zA-Z]*$/,
          },
        ],
        DeliveryDate: [
          { required: true, message: "请选择期望出货日期", trigger: "change" },
        ],
        DesAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      customerList: [], //客户
      
      isResouceShow: 0, // 绑定key值
      WareHouse: [], //仓库
   
      transportList: [], //运输方式
      channelList: [], //物流渠道
      addLoading: false,
      tableData: [],
      total: 0,
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
      Importtext: "", //导入返回信息
      importVisible: false,
      boxMarkVisible: false,
      transferdata: [],
      sels: [],
      pagetotal: 0,
      page: 1,
      pageSize: 20,
      choiceVisible: false,
      choicedata: [],
    };
  },
  methods: {
    //单选选中复选框
    handleCellClick(row, column, event) {
      console.log(this.$refs.multipleTable);
      this.$refs.multipleTable.$children[1].toggleRowSelection(row);
     
    },
    //多选
    selsChange(sels) {
      this.sels = sels;
    },
    //加载基础资料
    getWarebaselist() {
      let user = JSON.parse(window.localStorage.user);
      console.log(user.warehouseList);
      this.WareHouse = user.warehouseList.filter((m) => {
        return m.operateType === 1;
      });
    
    },
   
    //查询运输方式
    getTransport(){
       let pata = {
        warehouseId: this.addForm.WarehouseId,
  
      };
      this.transportList = [];
      this.addForm.Transport = "";
      getTransportType(pata).then((res) => {
      this.transportList = res.data.response;
    });

    },
    //查询物流渠道
    getLogisticsChannels() {
      let pata = {
        warehouseId: this.addForm.WarehouseId,
        transportTypeId: this.addForm.Transport,
      };
      this.channelList = [];
      this.addForm.LogisticsChannelID = "";
      if (this.addForm.WarehouseId != "" && this.addForm.Transport != "") {
        getLogisticsChannelsByChannelName(pata).then((res) => {
          this.channelList = res.data.response;
        });
      }
    },
    //弹出箱明细框
    getBoxMarkDetailed() {
      var orgID = this.addForm.OrgID;
      var warehouseId = this.addForm.WarehouseId;
      if (orgID == "" || orgID == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }
      if (warehouseId == "" || warehouseId == null) {
        this.$message({
          message: "请选择仓库",
          type: "error",
        });
        return;
      }
      let that = this;
      let pata = {
        warehouseId: warehouseId,
        orgID: orgID,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.transferdata = [];
      this.boxMarkVisible = true;
      getBatchBoxDetail(pata).then((res) => {
        if (res.data.success) {
          this.transferdata = res.data.response.pageData;
          this.pagetotal = res.data.response.total;
           that.$refs.multipleTable.$children[1].clearSelection();
           this.$nextTick(function () {
            for (let i = 0; i < this.transferdata.length; i++) {
              for (let j = 0; j < this.tableData.length; j++) {
                if (
                  this.transferdata[i].boxMark ===
                  this.tableData[j].boxMark
                ) {
                   that.$refs.multipleTable.$children[1].toggleRowSelection(this.transferdata[i],true);
                }
              }
            }
            
          });
        } else {
          this.$message({
            message: "箱明细查询失败",
            type: "error",
          });
        }
      });
    },
    //弹出常用地址
    commonlyUsed() {
      var orgID = this.addForm.OrgID;
      if (orgID == "" || orgID == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }
      let pata = {
        orgId: orgID,
        commonAddressType: 1,
      };
      this.choicedata = [];
      this.choiceVisible = true;
      getCommonAddressByOrgId(pata).then((res) => {
        if (res.data.success) {
          this.choicedata = res.data.response;
        } else {
          this.$message({
            message: "常用地址查询失败",
            type: "error",
          });
        }
      });
    },
    //选择常用地址
    choiceAddress(row) {
    
      this.addForm.DesAddress = row.address;
      this.choiceVisible = false;
    },
    //获取每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getBoxMarkDetailed();
    },
    //获取页码
    handleCurrentChange(val) {
      this.page = val;
      this.getBoxMarkDetailed();
    },
    //将选择的箱明细存入缓存
    onAddCachingBatchBox() {
      var sels = this.sels;
      if (sels == null || sels.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }
      let pata = {
        warehouseId: this.addForm.WarehouseId,
        orgID: this.addForm.OrgID,
        inventoryBatchBoxGaugeID: sels.map(
          (item) => item.inventoryBatchBoxGaugeID
        ),
      };
      addCachingBatchBox(pata).then((res) => {
        this.tableData = [];
        sels.forEach((item) => {
          let rowBox = { boxMark: item.boxMark, destinationBoxNo: "" };
          this.tableData.push(rowBox);
        });
        this.boxMarkVisible = false;
        this.total = this.tableData.length;
      });
    },
    //查询存入缓存的箱明细
    onGetCachingBatchBox() {
      let pata = {
        warehouseId: this.addForm.WarehouseId,
        orgID: this.addForm.OrgID,
      };
      this.tableData = [];
      this.total = 0;
      if (this.addForm.WarehouseId != "" && this.addForm.OrgID != "") {
        getCachingBatchBox(pata).then((res) => {
          this.tableData = res.data.response;
          this.total = this.tableData.length;
        });
      }
    },
    //删除箱唛
    delboxMark(boxMark) {
      this.$confirm("确认删除箱号" + boxMark + "吗?", "提示", {}).then(() => {
        const index = this.tableData.findIndex(
          (item) => item.boxMark === boxMark
        );
        if (index > -1) {
          this.tableData.splice(index, 1);
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.total = this.tableData.length;
        } else {
          this.$message({
            message: "删除失败",
            type: "error",
          });
        }
      });
    },
    //弹出导入文件框
    importExport() {
      var orgID = this.addForm.OrgID;
      var warehouseId = this.addForm.WarehouseId;
      if (orgID == "" || orgID == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }
      if (warehouseId == "" || warehouseId == null) {
        this.$message({
          message: "请选择仓库",
          type: "error",
        });
        return;
      }

      this.Importtext = "";
      this.importVisible = true;
    },
    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }
      return extension || extension2;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    //上传文件
    UploadExcel(param) {
      if (param == undefined) {
        this.$message({
          message: "请上传导入文件",
          type: "error",
        });
        return;
      }
      console.log(param, "文件");
      this.parafile = param;
      let para = new FormData();
      para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url:
          importImportBatchBox +
          "?warehouseId=" +
          this.addForm.WarehouseId +
          "&orgID=" +
          this.addForm.OrgID,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            this.parafile = "";
            console.log("导入成功");
            param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.onGetCachingBatchBox();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
            param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },
    //新增
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
  
      if (this.tableData.length == 0) {
        this.$message({
          message: "请录入箱明细数据",
          type: "error",
        });
        return;
      }
      for (var i = 0; i < this.tableData.length; i++) {
        if (
          this.tableData[i].destinationBoxNo == "" ||
          this.tableData[i].destinationBoxNo == null
        ) {
          this.$message({
            message:
              "箱号" + this.tableData[i].boxMark + "FBA/海外仓箱号不能为空",
            type: "error",
          });
          return false; //必须返回false
        }
        var reg = /^[0-9a-zA-Z]*$/;
        if (!reg.test(this.tableData[i].destinationBoxNo)) {
          this.$message({
            message:
              "箱号" +
              this.tableData[i].boxMark +
              "FBA/海外仓箱号只能输入字母、数字",
            type: "error",
          });
          return false;
        }
      }
      para.BatchBoxList = this.tableData;

      let _this = this;
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              var user = JSON.parse(window.localStorage.user);
              if (!user && user.id == 0) {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect
                    ? _this.$route.query.redirect
                    : "/"
                );
              }

              this.addLoading = true;
              console.log(para);

              addReadyforTask(para).then((res) => {
                this.addLoading = false;
                console.log(res);
                if (res.data.success) {
                  this.$refs["addRuleForm"].resetFields();
                  this.tableData = [];
                  this.total = 0;
                  this.$alert(
                    "备货单号：" +
                      res.data.msg +
                      "，可在备货任务页面查询",'提交成功',
                    {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        window.parent.postMessage("close", "*");
                      },
                    }
                  );
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    //下载模板
    handleDownload() {
      let url = downloadBatchBox;
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
    //查询备货单明细
    onGetStockingTaskById(stockingTaskID) {
      if (stockingTaskID == 0 || stockingTaskID == undefined) {
        this.$message({
          message: "备货单ID错误",
          type: "error",
        });
        return;
      }
      let pata = {
        stockingTaskID: stockingTaskID,
      };
      getStockingTaskById(pata).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response.batchBoxList;
          this.total = this.tableData.length;
          this.addForm.StockingTaskID = res.data.response.stockingTaskID;
          this.addForm.OrgID = res.data.response.orgID;
          this.addForm.WarehouseId = res.data.response.warehouseId;
           this.getTransport();
          this.addForm.Transport = res.data.response.transport;
        
          this.getLogisticsChannels();
          this.addForm.LogisticsChannelID =
            res.data.response.logisticsChannelID;
         

          this.addForm.ContainerNo = res.data.response.containerNo;
          this.addForm.DeliveryDate = res.data.response.deliveryDate;
          this.addForm.DesAddress = res.data.response.desAddress;
          this.addForm.IsHandleThridBoxMark =
            res.data.response.isHandleThridBoxMark;
          this.addForm.IsHandleChannelBoxMark =
            res.data.response.isHandleChannelBoxMark;
        } else {
          this.$message({
            message: "备货单ID错误",
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    let para = {
      IsAll: false,
    };
    getCustomerList(para).then((res) => {
      this.customerList = res.data.response;
    });
    this.getWarebaselist();
    
    var query = this.$route.query;
    console.log("dd", query.stockingTaskID);
    if (query.stockingTaskID != undefined) {
      this.onGetStockingTaskById(query.stockingTaskID);
    }
    if (query.warehouseId != undefined && query.orgID != undefined) {
      this.addForm.WarehouseId = parseInt(query.warehouseId);
      this.getTransport();
      console.log(typeof query.warehouseId);
      this.addForm.OrgID = parseInt(query.orgID);
      this.onGetCachingBatchBox();
    }
  },
   
};
</script>
